<template>
	<div class="contentPage">
		<main-table
				v-if="reportsFilter"
				default-sort-by="id"
				:default-sort-desc="true"
				:headers="headers"
				:listItems="reportsList"
				:filtersList="reportsFilter"
				@updateClickButton="onClickButton"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
				:flag="tabFlag"
				:pageTitle="tabPageTitle"
				:isExport="false"
				:isCreate="false"
				:isTabs="true"
		>
			<template slot="tabs">
				<tab-block
						:tab="tab"
						:tab-list="tabList"
						@updateTab="onTab"
				></tab-block>
			</template>
		</main-table>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"/>
		<confirm-email-sending
				v-if="isConfirm"
				:email="sendMail"
				@updateConfirmItem="sendReport"
				@updateConfirmClose="onConfirmClose"
				@updateConfirmEmailSending="onConfirmEmailSending"
		></confirm-email-sending>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TabBlock from "@/shared/TabBlock/TabBlock.vue";
import { reportHeader } from "@/constants/defaultHeader";
import { getAppUrl } from "@/services";
import PreviewDoc from "@/modules/invoices/preview.vue";
import ConfirmEmailSending
from "@/components/Statistics/ReportsOld/Reports-list/ConfirmEmailSending/ConfirmEmailSending.vue";
import { tabList } from "@/pages/Statistics/Reports/tabList";

export default {
	name: "Reports",
	components: { ConfirmEmailSending, PreviewDoc, TabBlock },

	computed: {
		...mapGetters([
			"reportsFilter",
			"reportsList",
		]),
		headers() {
			return reportHeader;
		},
		tabList() {
			return tabList;
		},
	},

	data: () => ({
		link: null,
		tab: 0,
		tabUrl: null,
		tabFlag: null,
		tabPageTitle: 'Customer reports',
		checkItemSend: null,
		sendMail: null,
		isConfirm: false,
	}),
	methods: {
		...mapActions([
			"onReports",
			"onReportFilter",
			"onReportSend",
		]),
		clearLink() {
			this.link = null;
		},
		previewAction(link) {
			this.link = getAppUrl + link;
		},
		onTab(index) {
			this.tab = index;
			this.tabUrl = this.tabList[index].url;
			this.tabFlag = this.tabList[index].flag;
			this.onReportsList(this.tabUrl);
		},
		async onReportsList(url) {
			await this.onReports(url);
		},
		async onFilter(args) {
			const url = this.tabUrl;
			const filter = args.filterModList;

			await this.onReportFilter({ filter, url });
		},
		onClickButton({ key, item }) {
			if (key === "file") {
				this.previewAction(item.file);
			}
			if (key === "send") {
				this.sendInvoiceCheck(item);
			}
		},
		sendInvoiceCheck(item) {
			this.checkItemSend = item;
			this.sendMail = item['send_to'];
			this.isConfirm = true;
		},
		onConfirmClose() {
			this.isConfirm = false;
		},
		onConfirmEmailSending(value) {
			this.sendMail = value;
		},
		async sendReport() {
			this.isConfirm = false;
			const id = this.checkItemSend.id;
			const email = this.sendMail;
			const url = this.tabUrl;
			await this.onReportSend({ id, email, url });
			await this.onReports(this.tabList[0].url);
		},
	},
	async mounted() {
		await this.onReports(this.tabList[0].url);
		this.tabUrl = this.tabList[0].url;
		this.tabFlag = this.tabList[0].flag;
	},
};
</script>

<style lang="scss" scoped>
@import "./reports";
</style>

